import React from "react";
import { toast } from "react-toastify";

const InputError = (props) => {
    return(
        <span style={{fontSize: '13px', color: 'red'}}>{props.message}</span>
    )
}

export default InputError;
